import FormContent from './form-content.container'

export default FormContent